import { ReactNode, useEffect } from 'react';
import {
  WBBadge,
  WBListItem,
  WBListItemIcon,
  WBListItemText,
} from '@admiin-com/ds-web';
import { ListItemLinkButton } from '../../../../../components';
import { styled, useTheme } from '@mui/material';
import LoadSvgIcon from '../../../../../component/LoadSvgIcon/LoadSvgIcon';
import { useLocation } from 'react-router-dom';

export interface NavItemProps {
  title: string | ReactNode;
  icon: ReactNode;
  path: string;
  onClick?: () => void;
  hasBadge?: boolean;
  badgeColor?: string;
  badgeCount?: number;
  noTitle?: boolean;
}

const StyledNavItem = styled(WBListItem)<{ noTitle?: boolean }>(
  ({ theme, noTitle }) => ({
    paddingLeft: noTitle ? '16px' : 'undefined',
    paddingRight: noTitle ? '16px' : undefined,
    paddingTop: noTitle ? '8px' : undefined,
    paddingBottom: noTitle ? '8px' : undefined,
    '& .MuiListItemButton-root': {
      // padding: noTitle ? '16px' : undefined,
    },
    '& .MuiListItemIcon-root': {
      minWidth: noTitle ? 14 : 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      '& .MuiListItemIcon-root': {
        minWidth: noTitle ? 14 : 28,
      },
    },
  })
);

export const NavItem = ({
  path,
  icon,
  title,
  onClick,
  badgeColor,
  badgeCount,
  hasBadge,
  noTitle,
}: NavItemProps) => {
  const theme = useTheme();
  const { pathname } = useLocation();

  const isActive = pathname.includes(path ?? '');
  return (
    <StyledNavItem noTitle={noTitle}>
      <ListItemLinkButton
        to={path}
        onNavigated={onClick}
        sx={{
          padding: 1,
          bgcolor: isActive ? 'primary.light' : 'transparent',
          borderRadius: '8px',
        }}
      >
        <WBListItemIcon>
          <WBBadge
            color={badgeCount ? 'error' : (badgeColor as any)}
            variant={badgeCount ? 'standard' : 'dot'}
            badgeContent={badgeCount || undefined}
            invisible={!hasBadge && !badgeCount}
            sx={
              badgeCount
                ? {
                    '& .MuiBadge-badge': {
                      fontSize: '0.6rem',
                      height: 16,
                      minWidth: 16,
                    },
                  }
                : undefined
            }
          >
            <LoadSvgIcon
              component={icon}
              fill={
                isActive
                  ? theme.palette.primary.main
                  : theme.palette.text.primary
              }
            />
          </WBBadge>
        </WBListItemIcon>
        <WBListItemText
          primary={noTitle ? null : title}
          primaryTypographyProps={{
            sx: {
              fontWeight: isActive ? 700 : 400,
              color: isActive ? 'primary.main' : 'text.primary',
            },
          }}
        />
      </ListItemLinkButton>
    </StyledNavItem>
  );
};
